// ScienceLessonUI.js
import React from "react";
import { Link } from "react-router-dom";

export default function ScienceLessonUI({
  pages,
  currentPageIndex,
  onPrevPage,
  onNextPage,
  onStartQuiz,
  backTo
}) {
  const page = pages[currentPageIndex];

  return (
    <div className="lesson-book-container">
      <h2 className="lesson-page-title">{page.title}</h2>
      <div className="lesson-page-content">{page.content}</div>

      <div className="lesson-page-navigation" style={{ marginTop: 24 }}>
        {/* Previous Button (if not on first page) */}
        {onPrevPage && (
          <button className="lesson-nav-btn" onClick={onPrevPage}>
            ◀ Previous
          </button>
        )}

        {/* Only show ONE primary action: Start Quick Quiz OR Next */}
        {onStartQuiz ? (
          <button className="lesson-nav-btn" onClick={onStartQuiz}>
            Start Quick Quiz
          </button>
        ) : onNextPage ? (
          <button className="lesson-nav-btn" onClick={onNextPage}>
            Next ▶
          </button>
        ) : null}
      </div>

      {/* Back link, if needed */}
      {backTo && (
        <Link to={backTo} className="grade1-math-back">
          ← Back
        </Link>
      )}
    </div>
  );
}
